import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Avatar from 'components/common/Avatar';
import UserDropdownV2 from 'components/dropdowns/CustomerServices/UserDropdownV2';
import { buildTargetTextDisplay } from 'helpers/kpiHelper';
import { MesuarableTdItem } from './MesuarableTdItem/MesuarableTdItem';
import classNames from 'classnames';
import { getUsername } from 'services/userServices';

function SectorTableRow({
  item,
  index,
  timesAgo,
  idEditing,
  setIdEditing,
  handleSaveUserIncharge,
  toggleMesurabledModal,
  setMesurableData,
  toggleTargetSettingdModal,
  setTargetSettingData,
  selectedCurrentMonth,
  selectedSubOneMonth,
  sheduleTypeId,
  measurables,
  getMeasurables,
  noOfCol
}) {
  return (
    <tr>
      <td className="text-center p-1">
        <i>
          <b>{index + 1}</b>
        </i>
      </td>

      <td
        className="p-1"
        onClick={() => {
          toggleMesurabledModal();
          setMesurableData(item);
        }}
      >
        {item.compareType == 1 ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{'Value < Target'}</Tooltip>}
          >
            <i>
              <b>{item.name}</b>
            </i>
          </OverlayTrigger>
        ) : (
          <i>
            <b>{item.name}</b>
          </i>
        )}
      </td>

      {/* Previous Target */}
      <td
        className="text-center p-1"
        onClick={() => {
          toggleTargetSettingdModal();
          setTargetSettingData({
            ...item,
            date: selectedSubOneMonth,
            target: item.previousMonthTarget?.target
          });
        }}
      >
        {buildTargetTextDisplay(
          item.targetTypeValue,
          item.previousMonthTarget?.target?.toLocaleString('en-US'),
          item.targetType,
          item.numOfDecimal
        )}
      </td>

      {/* Current Target */}
      <td
        className="text-center p-1"
        onClick={() => {
          toggleTargetSettingdModal();
          setTargetSettingData({
            ...item,
            date: selectedCurrentMonth,
            target: item.currentMonthTarget?.target
          });
        }}
      >
        {buildTargetTextDisplay(
          item.targetTypeValue,
          item.currentMonthTarget?.target?.toLocaleString('en-US'),
          item.targetType,
          item.numOfDecimal
        )}
      </td>

      {/* User */}
      <td className={classNames('text-center p-1')}>
        <div
          onClick={() => setIdEditing(item.id)}
          onBlur={() => setIdEditing(0)}
        >
          {item.id === idEditing ? (
            <UserDropdownV2
              fieldName="inChargeUserId"
              handleChange={(_, option) =>
                handleSaveUserIncharge(option, item.id)
              }
              placeholder=""
              isMulti={false}
              value={item?.inChargeUserId}
            />
          ) : (
            <Avatar
              size="xl"
              name={getUsername(item?.inChargeUserId)}
              className="me-2"
            />
          )}
        </div>
      </td>

      <td className="text-center p-1">{item.variationPercentage}%</td>

      {timesAgo.map((time, idx) => (
        <MesuarableTdItem
          key={idx}
          sheduleTypeId={sheduleTypeId}
          data={measurables}
          item={item}
          col={time.date}
          value={item[`time${time.index}`]?.value?.toLocaleString('en-US')}
          callback={getMeasurables}
          noOfCol={noOfCol - time.index}
          compareNoOfCol={noOfCol}
        />
      ))}
    </tr>
  );
}

SectorTableRow.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  timesAgo: PropTypes.array,
  idEditing: PropTypes.number,
  setIdEditing: PropTypes.func,
  handleSaveUserIncharge: PropTypes.func,
  toggleMesurabledModal: PropTypes.func,
  setMesurableData: PropTypes.func,
  toggleTargetSettingdModal: PropTypes.func,
  setTargetSettingData: PropTypes.func,
  selectedCurrentMonth: PropTypes.instanceOf(Date),
  selectedSubOneMonth: PropTypes.instanceOf(Date),
  sheduleTypeId: PropTypes.number,
  measurables: PropTypes.array,
  getMeasurables: PropTypes.func,
  noOfCol: PropTypes.number
};

export default SectorTableRow;
